import { inject, provide } from 'vue';
const insightsModalKey = Symbol('InsightsModal');
export function useInsightsModalContextProvider(insightsModal) {
    provide(insightsModalKey, insightsModal);
}
export function useInsightsModalContext() {
    const context = inject(insightsModalKey);
    if (!context) {
        throw new Error('useInsightsModalContext must be used within a provider');
    }
    return context;
}
